"use client"

import { Group, Panel, Separator, usePanelRef, useGroupRef } from "react-resizable-panels"
import type { PanelImperativeHandle, GroupImperativeHandle } from "react-resizable-panels"

import { cn } from "@/common/lib/utils"

const ResizablePanelGroup = ({
  className,
  orientation = "horizontal",
  ...props
}: React.ComponentProps<typeof Group>) => (
  <Group
    className={cn(
      "flex h-full w-full",
      orientation === "vertical" && "flex-col",
      className
    )}
    orientation={orientation}
    {...props}
  />
)

const ResizablePanel = Panel

const ResizableHandle = ({
  className,
  ...props
}: React.ComponentProps<typeof Separator>) => (
  <Separator
    className={cn(
      "group/handle relative flex w-0.5 items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-3 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 [&[data-orientation=vertical]]:h-0.5 [&[data-orientation=vertical]]:w-full [&[data-orientation=vertical]]:after:left-0 [&[data-orientation=vertical]]:after:h-3 [&[data-orientation=vertical]]:after:w-full [&[data-orientation=vertical]]:after:-translate-y-1/2 [&[data-orientation=vertical]]:after:translate-x-0",
      className
    )}
    {...props}
  >
    <div className="absolute left-1 z-10 h-8 w-1 rounded-full bg-muted-foreground/20 opacity-0 transition-opacity group-hover/handle:opacity-100 group-active/handle:opacity-100 [&[data-orientation=vertical]]:left-auto [&[data-orientation=vertical]]:h-1 [&[data-orientation=vertical]]:w-8" />
  </Separator>
)

export { ResizablePanelGroup, ResizablePanel, ResizableHandle, usePanelRef, useGroupRef }
export type { PanelImperativeHandle, GroupImperativeHandle }
